import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb87bb8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scanned__wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "scanned__list" }

import ArticleQuantityCardSliding from '@components/article/ArticleQuantityCardSliding.vue';
import { IScannedArticle } from '@/const/types/article';

interface Props {
    scannedArticles: IScannedArticle[];
    isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryScannedList',
  props: {
    scannedArticles: null,
    isLoading: { type: Boolean }
  },
  emits: ["openChangeQuantityAlert", "deleteSingleArticle"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'openChangeQuantityAlert', article: IScannedArticle): void
    (e: 'deleteSingleArticle', article: IScannedArticle): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    scannedArticles: IScannedArticle[];
    isLoading: boolean;
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.scannedArticles.length < 1 && !props.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Scan article. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.scannedArticles, (article) => {
              return (_openBlock(), _createElementBlock("li", {
                key: article.code
              }, [
                _createVNode(ArticleQuantityCardSliding, {
                  article: article,
                  onChangeArticleQuantity: _cache[0] || (_cache[0] = () => {}),
                  onOpenChangeQuantityAlert: ($event: any) => (emit('openChangeQuantityAlert', article)),
                  onDeleteSingleArticle: ($event: any) => (emit('deleteSingleArticle', article))
                }, {
                  right: _withCtx(() => [
                    _createTextVNode(_toDisplayString(article.quantity) + " szt. ", 1)
                  ]),
                  _: 2
                }, 1032, ["article", "onOpenChangeQuantityAlert", "onDeleteSingleArticle"])
              ]))
            }), 128))
          ])
        ]))
  ]))
}
}

})